"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import H1 from "./H1";
import { serif as mckay, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled(H1).withConfig({
  componentId: "sc-n36lmc-0"
})(["font-family:", ";font-weight:", ";"], mckay, fontWeightNormal);

/**
 * Used in Article Template for Scriptures and General Conference. This style needs to be used sparingly across the organization.
 */
const MoreFormalH1 = _ref => {
  let {
    children,
    small,
    renderAs,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Container, {
    small: small,
    forwardedAs: renderAs,
    ...props,
    children: children
  });
};
export default MoreFormalH1;
MoreFormalH1.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,
  /** Whether smaller styles should be applied */
  small: PropTypes.bool,
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};